export const navLinks = [
  { label: '首页', href: '/' },
  { label: '赛事直播', href: '/category/live' },
  { label: '数据分析', href: '/category/data' },
  { label: '足球互动', href: '/category/interactive' },
  { label: '最新活动', href: '/category/events' },
  { label: '关于我们', href: '/about' },
];